<script lang="ts">
  import { errorTracker, postWithJwt } from "lib";
  import { dialogData, showAlert, selectedWorkoutIds } from "stores";
  import { ButtonComponent, CheckboxComponent } from "ui";

  let isLoading = false;

  const tags = [
    "Trbuh",
    "Biceps",
    "Listovi",
    "Grudi",
    "Podlaktica",
    "Zadnjica",
    "Zadnja loža",
    "Donja leđa",
    "Prednja Loža",
    "Ramena",
    "Triceps",
    "Gornja leđa",
  ];
  let selected: Array<string> = [];

  const tagsMap = new Map([
    ["Trbuh", "ABS"],
    ["Biceps", "BICEPS"],
    ["Listovi", "CALVES"],
    ["Grudi", "CHEST"],
    ["Podlaktica", "FOREARM"],
    ["Zadnjica", "GLUTE"],
    ["Zadnja loža", "HAMSTRINGS"],
    ["Donja leđa", "LOWER_BACK"],
    ["Prednja Loža", "QUADS"],
    ["Ramena", "SHOULDERS"],
    ["Triceps", "TRICEPS"],
    ["Gornja leđa", "UPPER_BACK"],
  ]);

  const onSelect = (tag: string): void => {
    if (selected.includes(tag)) {
      selected = selected.filter((s) => s !== tag);
    } else {
      selected = [...selected, tag];
    }
  };

  const onEdit = async (): Promise<void> => {
    try {
      isLoading = true;
      // ovo ne radi na bekend?
      const response = await postWithJwt(``, {
        tags: selected.map((s) => tagsMap.get(s)),
        exerciseIds: $selectedWorkoutIds,
      });

      $dialogData.data = {};
      $dialogData.type = "";

      $showAlert.color = "black";
      $showAlert.message = `Izmenjena misicna grupa`;
    } catch (error) {
      errorTracker.captureError(error as Error, 'error', {
        component: 'SelectMuscleGroup',
        action: 'onEdit',
        context: 'Failed to update muscle group for exercises',
        selectedTags: selected.length,
        exerciseIds: $selectedWorkoutIds?.length || 0
      });
      isLoading = false;
      $showAlert.color = "red-400";
      $showAlert.message = `Greska pri menjanju misicne grupe`;
    }
  };
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-center font-semibold">Mišićna grupa</div>

  <div class="flex flex-col gap-2">
    {#each tags as tag}
      <CheckboxComponent
        label={tag}
        value={selected.includes(tag)}
        on:change={() => onSelect(tag)}
      />
    {/each}
  </div>

  <div class="flex justify-center">
    <ButtonComponent
      {isLoading}
      disabled={!selected.length}
      on:click={onEdit}
    >
      Izmeni
    </ButtonComponent>
  </div>
</div>
